import React from "react";
import Section from "./section";
import Reveal from "./reveal";
import Button from "./button";
import FAQList from "./faq-list";

/** Two-column FAQ block: intro on the left, accordion on the right. */
export default function FAQSection({ title, text, items, tone = "light", link = false }) {
  return (
    <Section tone={tone}>
      <div className="faq-wrap">
        <Reveal className="faq-sticky">
          <div className="kicker">FAQ</div>
          <h2>{title}</h2>
          {text && <p className="large-copy">{text}</p>}
          {link && <Button to="/faq" variant="secondary">See All FAQs</Button>}
        </Reveal>
        <FAQList items={items} />
      </div>
    </Section>
  );
}
